import React from 'react';
import propTypes from 'prop-types';
import { TireCard } from './TireCard';
import { productPropTypes } from './productPropTypes';

const TireCards = ({
  isSplitFitment,
  product,
  product2,
  pricing,
}) => (
  isSplitFitment
    ? (
      <>
        <TireCard
          isSplitFitment
          pricing={pricing}
          product={product}
          frontTire
        />
        <TireCard
          isSplitFitment
          pricing={pricing}
          product={product2}
          frontTire={false}
        />
      </>
    ) : (
      <TireCard
        isSplitFitment={false}
        pricing={pricing}
        frontTire
        product={product}
      />
    )
);

TireCards.propTypes = {
  isSplitFitment: propTypes.bool,
  product: productPropTypes,
  product2: productPropTypes,
  pricing: propTypes.shape({
    isValidPrice: propTypes.bool,
    pricingGroup: propTypes.string,
  }),
};

export { TireCards };
